export const isDebugMode = () =>
  typeof window !== 'undefined' &&
  localStorage.getItem('contour-debug-sync') === 'true'
